module.exports = "/img/story-3.534a71fe.png";